"use strict";
/**
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [https://neo4j.com]
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var neo4j_driver_core_1 = require("neo4j-driver-core");
var stream_observers_1 = require("./stream-observers");
var query_codec_1 = require("./query.codec");
var transaction_codec_1 = require("./transaction.codec");
var pipe_1 = __importDefault(require("./lang/pipe"));
var currentId = 0;
var HttpConnection = /** @class */ (function (_super) {
    __extends(HttpConnection, _super);
    function HttpConnection(config) {
        var _this = this;
        var _a;
        _this = _super.call(this) || this;
        _this._id = currentId++;
        _this._release = config.release;
        _this._auth = config.auth;
        _this._queryEndpoint = config.queryEndpoint;
        _this._config = config.config;
        _this._log = config.logger;
        _this._errorHandler = config.errorHandler;
        _this._open = true;
        _this._currentTx = undefined;
        _this._workPipe = new pipe_1.default(config.logger);
        _this._abortControllers = [];
        _this._sessionAffinityHeader = (_a = config.config.httpSessionAffinityHeader) !== null && _a !== void 0 ? _a : 'neo4j-cluster-affinity';
        return _this;
    }
    HttpConnection.prototype.run = function (query, parameters, config) {
        var _this = this;
        var _a, _b;
        var observer = new stream_observers_1.ResultStreamObserver({
            highRecordWatermark: (_a = config === null || config === void 0 ? void 0 : config.highRecordWatermark) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER,
            lowRecordWatermark: (_b = config === null || config === void 0 ? void 0 : config.lowRecordWatermark) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER,
            afterComplete: config === null || config === void 0 ? void 0 : config.afterComplete,
            beforeError: config === null || config === void 0 ? void 0 : config.beforeError,
            server: this._address,
        });
        var requestCodec = query_codec_1.QueryRequestCodec.of(this._auth, query, parameters, config);
        var abortController = this._newAbortController();
        this._workPipe.attach(function () { return __awaiter(_this, void 0, void 0, function () {
            var request, res, _a, rawQueryResponse, _b, contentType, batchSize, codec, stream, i, _c, done, rawRecord;
            var _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        request = {
                            url: this._getTransactionApi(config === null || config === void 0 ? void 0 : config.database),
                            method: 'POST',
                            mode: 'cors',
                            headers: this._headers(requestCodec),
                            signal: abortController.signal,
                            body: JSON.stringify(requestCodec.body)
                        };
                        (_d = this._log) === null || _d === void 0 ? void 0 : _d.debug("".concat(this, " REQUEST: ").concat(JSON.stringify(request)));
                        return [4 /*yield*/, fetch(request.url, request)];
                    case 1:
                        res = _g.sent();
                        return [4 /*yield*/, readBodyAndReaders(request.url, res, 'content-type')];
                    case 2:
                        _a = _g.sent(), rawQueryResponse = _a.body, _b = __read(_a.headers, 1), contentType = _b[0];
                        (_e = this._log) === null || _e === void 0 ? void 0 : _e.debug("".concat(this, " RESPONSE: { body: ").concat(JSON.stringify(rawQueryResponse), ", headers: { content-type: ").concat(contentType, " }}"));
                        batchSize = (_f = config === null || config === void 0 ? void 0 : config.fetchSize) !== null && _f !== void 0 ? _f : Number.MAX_SAFE_INTEGER;
                        codec = query_codec_1.QueryResponseCodec.of(this._config, contentType !== null && contentType !== void 0 ? contentType : '', rawQueryResponse);
                        if (codec.error) {
                            throw codec.error;
                        }
                        observer.onKeys(codec.keys);
                        stream = codec.stream();
                        _g.label = 3;
                    case 3:
                        if (!!observer.completed) return [3 /*break*/, 6];
                        if (!observer.paused) return [3 /*break*/, 5];
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 20); })];
                    case 4:
                        _g.sent();
                        return [3 /*break*/, 3];
                    case 5:
                        for (i = 0; !observer.paused && i < batchSize && !observer.completed; i++) {
                            _c = stream.next(), done = _c.done, rawRecord = _c.value;
                            if (!done) {
                                observer.onNext(rawRecord);
                            }
                            else {
                                observer.onCompleted(codec.meta);
                            }
                        }
                        return [3 /*break*/, 3];
                    case 6:
                        observer.onCompleted(codec.meta);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(this._catch(observer))
            .finally(this._finally(abortController));
        return observer;
    };
    HttpConnection.prototype._headers = function (requestCodec) {
        var _a;
        var headers = {
            'Content-Type': requestCodec.contentType,
            Accept: requestCodec.accept,
            Authorization: requestCodec.authorization,
        };
        if (((_a = this._currentTx) === null || _a === void 0 ? void 0 : _a.affinity) != null) {
            headers[this._sessionAffinityHeader] = this._currentTx.affinity;
        }
        return headers;
    };
    HttpConnection.prototype.beginTransaction = function (config) {
        var _this = this;
        var observer = new stream_observers_1.ResultStreamObserver({
            server: this._address,
            afterComplete: config === null || config === void 0 ? void 0 : config.afterComplete,
            beforeError: config.beforeError,
            highRecordWatermark: Number.MAX_SAFE_INTEGER,
            lowRecordWatermark: Number.MIN_SAFE_INTEGER,
        });
        observer.prepareToHandleSingleResponse();
        var requestCodec = transaction_codec_1.BeginTransactionRequestCodec.of(this._auth, config);
        var abortController = this._newAbortController();
        this._workPipe.attach(function () { return __awaiter(_this, void 0, void 0, function () {
            var request, res, _a, rawBeginTransactionResponse, _b, contentType, affinity, codec;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        request = {
                            url: this._getExplicityTransactionApi(config === null || config === void 0 ? void 0 : config.database),
                            method: 'POST',
                            mode: 'cors',
                            headers: this._headers(requestCodec),
                            signal: abortController.signal,
                            body: JSON.stringify(requestCodec.body)
                        };
                        (_c = this._log) === null || _c === void 0 ? void 0 : _c.debug("".concat(this, " REQUEST: ").concat(JSON.stringify(request), " "));
                        return [4 /*yield*/, fetch(request.url, request)];
                    case 1:
                        res = _e.sent();
                        return [4 /*yield*/, readBodyAndReaders(request.url, res, 'content-type', this._sessionAffinityHeader)];
                    case 2:
                        _a = _e.sent(), rawBeginTransactionResponse = _a.body, _b = __read(_a.headers, 2), contentType = _b[0], affinity = _b[1];
                        (_d = this._log) === null || _d === void 0 ? void 0 : _d.debug("".concat(this, " RESPONSE: { body: ").concat(JSON.stringify(rawBeginTransactionResponse), ", headers: { content-type: ").concat(contentType, ", ").concat(this._sessionAffinityHeader, ": ").concat(affinity, " }}"));
                        codec = transaction_codec_1.BeginTransactionResponseCodec.of(this._config, contentType !== null && contentType !== void 0 ? contentType : '', rawBeginTransactionResponse);
                        if (codec.error != null) {
                            throw codec.error;
                        }
                        this._currentTx = {
                            id: codec.id,
                            host: codec.host,
                            expires: codec.expires,
                            database: config === null || config === void 0 ? void 0 : config.database,
                        };
                        if (affinity != null) {
                            this._currentTx.affinity = affinity;
                        }
                        observer.onCompleted({});
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(this._catch(observer))
            .finally(this._finally(abortController));
        return observer;
    };
    HttpConnection.prototype.commitTransaction = function (config) {
        var _this = this;
        var observer = new stream_observers_1.ResultStreamObserver({
            server: this._address,
            afterComplete: config === null || config === void 0 ? void 0 : config.afterComplete,
            beforeError: config.beforeError,
            highRecordWatermark: Number.MAX_SAFE_INTEGER,
            lowRecordWatermark: Number.MIN_SAFE_INTEGER,
        });
        observer.prepareToHandleSingleResponse();
        var requestCodec = transaction_codec_1.CommitTransactionRequestCodec.of(this._auth, config);
        var abortController = this._newAbortController();
        this._workPipe.attach(function () { return __awaiter(_this, void 0, void 0, function () {
            var request, res, _a, rawCommitTransactionResponse, _b, contentType, codec;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        request = {
                            url: this._getTransactionCommitApi(),
                            method: 'POST',
                            mode: 'cors',
                            headers: this._headers(requestCodec),
                            signal: abortController.signal,
                            body: JSON.stringify(requestCodec.body)
                        };
                        (_c = this._log) === null || _c === void 0 ? void 0 : _c.debug("".concat(this, " REQUEST: ").concat(JSON.stringify(request), " "));
                        return [4 /*yield*/, fetch(request.url, request)];
                    case 1:
                        res = _e.sent();
                        return [4 /*yield*/, readBodyAndReaders(request.url, res, 'contentType')];
                    case 2:
                        _a = _e.sent(), rawCommitTransactionResponse = _a.body, _b = __read(_a.headers, 1), contentType = _b[0];
                        (_d = this._log) === null || _d === void 0 ? void 0 : _d.debug("".concat(this, " RESPONSE: { body: ").concat(JSON.stringify(rawCommitTransactionResponse), ", headers: { content-type: ").concat(contentType, " }}"));
                        codec = transaction_codec_1.CommitTransactionResponseCodec.of(this._config, contentType !== null && contentType !== void 0 ? contentType : '', rawCommitTransactionResponse);
                        if (codec.error) {
                            throw codec.error;
                        }
                        this._currentTx = undefined;
                        observer.onCompleted(codec.meta);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(this._catch(observer))
            .finally(this._finally(abortController));
        return observer;
    };
    HttpConnection.prototype.rollbackTransaction = function (config) {
        var _this = this;
        var observer = new stream_observers_1.ResultStreamObserver({
            server: this._address,
            afterComplete: config === null || config === void 0 ? void 0 : config.afterComplete,
            beforeError: config.beforeError,
            highRecordWatermark: Number.MAX_SAFE_INTEGER,
            lowRecordWatermark: Number.MIN_SAFE_INTEGER,
        });
        observer.prepareToHandleSingleResponse();
        var requestCodec = transaction_codec_1.RollbackTransactionRequestCodec.of(this._auth, config);
        var abortController = this._newAbortController();
        this._workPipe.attach(function () { return __awaiter(_this, void 0, void 0, function () {
            var request, res, _a, rawRollbackTransactionResponse, _b, contentType, codec;
            var _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        request = {
                            url: this._getTransactionApi((_c = this._currentTx) === null || _c === void 0 ? void 0 : _c.database),
                            method: 'DELETE',
                            mode: 'cors',
                            headers: this._headers(requestCodec),
                            signal: abortController.signal,
                            body: JSON.stringify(requestCodec.body)
                        };
                        (_d = this._log) === null || _d === void 0 ? void 0 : _d.debug("".concat(this, " REQUEST: ").concat(JSON.stringify(request), " "));
                        return [4 /*yield*/, fetch(request.url, request)];
                    case 1:
                        res = _f.sent();
                        return [4 /*yield*/, readBodyAndReaders(request.url, res, 'content-type')];
                    case 2:
                        _a = _f.sent(), rawRollbackTransactionResponse = _a.body, _b = __read(_a.headers, 1), contentType = _b[0];
                        (_e = this._log) === null || _e === void 0 ? void 0 : _e.debug("".concat(this, " RESPONSE: { body: ").concat(JSON.stringify(rawRollbackTransactionResponse), ", headers: { content-type: ").concat(contentType, " }}"));
                        codec = transaction_codec_1.RollbackTransactionResponseCodec.of(this._config, contentType !== null && contentType !== void 0 ? contentType : '', rawRollbackTransactionResponse);
                        if (codec.error) {
                            throw codec.error;
                        }
                        this._currentTx = undefined;
                        observer.onCompleted(codec.meta);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(this._catch(observer))
            .finally(this._finally(abortController));
        return observer;
    };
    HttpConnection.prototype._getTransactionApi = function (database) {
        if (this._currentTx === undefined) {
            return this._queryEndpoint.replace('{databaseName}', database);
        }
        return this._queryEndpoint.replace('{databaseName}', this._currentTx.database) + "/tx/".concat(this._currentTx.id);
    };
    HttpConnection.prototype._getTransactionCommitApi = function () {
        var _a, _b;
        return this._queryEndpoint.replace('{databaseName}', (_a = this._currentTx) === null || _a === void 0 ? void 0 : _a.database) + "/tx/".concat((_b = this._currentTx) === null || _b === void 0 ? void 0 : _b.id, "/commit");
    };
    HttpConnection.prototype._getExplicityTransactionApi = function (database) {
        return this._queryEndpoint.replace('{databaseName}', database) + '/tx';
    };
    HttpConnection.discover = function (_a) {
        var scheme = _a.scheme, address = _a.address;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(scheme, "://").concat(address.asHostPort()), {
                            headers: {
                                Accept: 'application/json',
                            }
                        })
                            .then(function (res) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, res.json()];
                                case 1: return [2 /*return*/, (_a.sent())];
                            }
                        }); }); })
                            .then(function (json) {
                            if (typeof json.query !== 'string') {
                                throw new Error('Query API is not available');
                            }
                            var query = json.query.endsWith('/') ? json.query.substring(0, json.query.length - 1) : json.query;
                            return { query: query, version: json.neo4j_version, edition: json.neo4j_edition };
                        })
                            .catch(function (e) {
                            throw (0, neo4j_driver_core_1.newError)("Failure discovering endpoints. Caused by: ".concat(e.message), 'SERVICE_UNAVAILABLE', e);
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    Object.defineProperty(HttpConnection.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpConnection.prototype, "auth", {
        get: function () {
            return this._auth;
        },
        set: function (auth) {
            this._auth = auth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HttpConnection.prototype, "queryEndpoint", {
        get: function () {
            return this._queryEndpoint;
        },
        set: function (queryEndpoint) {
            this._queryEndpoint = queryEndpoint;
        },
        enumerable: false,
        configurable: true
    });
    HttpConnection.prototype.getProtocolVersion = function () {
        return 0;
    };
    HttpConnection.prototype.isOpen = function () {
        return this._open;
    };
    HttpConnection.prototype.hasOngoingObservableRequests = function () {
        return this._abortControllers.length > 0;
    };
    HttpConnection.prototype.resetAndFlush = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._abortControllers.forEach(function (controller) { return controller.abort((0, neo4j_driver_core_1.newError)('User aborted operation.')); });
                this._abortControllers = [];
                this._currentTx = undefined;
                this._workPipe.recover();
                return [2 /*return*/];
            });
        });
    };
    HttpConnection.prototype.release = function () {
        this._workPipe.recover();
        return this._release();
    };
    HttpConnection.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._abortControllers.forEach(function (controller) { return controller.abort((0, neo4j_driver_core_1.newError)('Aborted since connection is being closed.')); });
                this._abortControllers = [];
                this._open = false;
                return [2 /*return*/];
            });
        });
    };
    HttpConnection.prototype.toString = function () {
        return "HttpConnection [".concat(this._id, "]");
    };
    HttpConnection.prototype._catch = function (observer) {
        var _this = this;
        return function (error) {
            _this._currentTx = undefined;
            var newError = _this._errorHandler(error);
            observer.onError(newError);
        };
    };
    HttpConnection.prototype._finally = function (abortController) {
        this._abortControllers = this._abortControllers.filter(function (ac) { return ac !== abortController; });
        return undefined;
    };
    HttpConnection.prototype._newAbortController = function () {
        var abortController = new AbortController();
        this._abortControllers.push(abortController);
        return abortController;
    };
    return HttpConnection;
}(neo4j_driver_core_1.Connection));
exports.default = HttpConnection;
function readBodyAndReaders(url, response) {
    var headers = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        headers[_i - 2] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
        var text, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, response.text()];
                case 1:
                    text = _a.sent();
                    return [2 /*return*/, {
                            body: text !== '' ? JSON.parse(text) : {},
                            headers: headers.map(function (header) { return response.headers.get(header); })
                        }];
                case 2:
                    error_1 = _a.sent();
                    throw (0, neo4j_driver_core_1.newError)("Failure accessing \"".concat(url, "\""), 'SERVICE_UNAVAILABLE', error_1);
                case 3: return [2 /*return*/];
            }
        });
    });
}
